import React from 'react';

import { Container as BootstrapContainer } from 'react-bootstrap';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

export type ContainerPropsT = {
  children?: React.ReactNode;
  className?: string;
  fluid?: true | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  hasBoxShadow?: boolean;
  rounded?: boolean;
  style?: React.CSSProperties;
};
export type ContainerT = React.FC<ContainerPropsT>;

export const Container: ContainerT = ({
  children,
  className,
  hasBoxShadow,
  rounded,
  ...props
}) => {
  const classes = mergeClassNameStrings(
    className,
    hasBoxShadow ? 'shadow-sm rounded' : rounded && 'rounded',
  );

  return (
    <BootstrapContainer className={classes} {...props}>
      {children}
    </BootstrapContainer>
  );
};
